<template>
  <div class="panel-admin-body dashboard-layout">
    <div class="d-flex title">
      <div class="pb-1"><modal-link modal-id="How to Use"></modal-link>{{ title }}</div>
      <smart-center-link page="Dashboard Layout" location="Header" />
      <div class="ml-auto">
        <span class="wizard-icon">
          <font-awesome-icon  v-tooltip="tooltipConfigShow" :icon="['fas', 'hat-wizard']" @click="$root.toggleWizardContent()"/>
        </span>
        <i v-show="this.$parent.displayShowMenuIcon && this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="$parent.toggleHeaderMenu()"></i>
        <i v-show="this.$parent.displayShowMenuIcon && !this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="$parent.toggleHeaderMenu()"></i>
      </div>
    </div>
    <company-menu></company-menu>    
    <div v-show="$root.getShowWizardContent()" class="wizard-content">
      <div class="wizard-content-column wizard-border col-4">
        <div class="w-100 d-flex">
          <div class="circle">1</div>
          <div class="wizard-text">
            To adjust the default menu appearance when the wRatings System opens, click to show the Side Menu Titles or Top Navigation Menu.
          </div>
        </div>
      </div>
      <div class="wizard-content-column wizard-border col-4">
        <div class="w-100 d-flex">
          <div class="circle">2</div>
          <div class="wizard-text">
            Click Save Wave Periods and Card Menus to auto-save your Dashboard selections. If not selected, the system defaults to your current Wave Period and the first drop-down menu option.
          </div>
        </div>
      </div>
      <div class="wizard-content-column-two-entries wizard-border col-4">
        <div class="w-100 d-flex">
          <div class="circle">3</div>  
          <div class="wizard-text">
            To change your Dashboard appearance, Select which Card appears in each Position from the drop-down menus.  The Dashboard shows one or two rows of Cards, and each row shows one, two or three Cards.
          </div>      
        </div>
        <div class="w-100 d-flex pt-3">
          <div class="circle">4</div>  
          <div class="wizard-text pt-2">
            Click Save Options.
          </div>      
        </div>
      </div>
    </div>
    <user-settings />
    <div class="dashboard-layout-border"></div>
    <div class="d-flex no-gutters justify-content-around">
      <div class="dashboard-preview-container">
        <div class="dashboard-layout-header"><div class="text-center">Dashboard Preview</div></div>
        <div class="dashboard-card-container">
          <div
            v-for="(dashboardCard, idxDashboardCard) in dashboardLayoutCards"
            v-bind:key="idxDashboardCard"
            @change="enableSaveOptionsButton = true"
            :class="getClass(dashboardCard.dashboardCardTypeCode, dashboardCard.sequenceNumber, true)"
          ></div>
        </div>
      </div>
      <div class="dashboard-options-container">
        <div class="dashboard-layout-header">Display Options</div>
        <div class="text-center">
          Adjust how your dashboard appears when <br />
          you log into the wRatings system.
        </div>
        <div class="dashboard-display-options">
          <div class="mx-auto">
            <div v-for="(dashboardCard, idxDashboardCard) in dashboardLayoutCards" v-bind:key="idxDashboardCard" @change="enableSaveOptionsButton = true" class="form-group form-inline">
              <div class="pr-2">Position {{ dashboardCard.sequenceNumber }}</div>
              <div>
                <select id="dashboard_card_options" class="custom-select required w-100" v-model="dashboardCard.dashboardCardTypeCode">
                  <option value="">Leave Blank</option>
                  <option
                    v-for="(dashboard_card_type_option, idxDashboardCardTypeOptions) in dashboardCardTypeOptions"
                    v-bind:value="dashboard_card_type_option.code"
                    v-bind:key="idxDashboardCardTypeOptions"
                  >
                    <span>{{ dashboard_card_type_option.name }}</span>
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-primary float-right pt-2 mr-4" :disabled="!this.enableSaveOptionsButton" @click="this.saveOptions">
                <span>Save Options</span>
                <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard-layout-border"></div>
  </div>
</template>
<script>
import DashboardService from "../../services/dashboard.service";
import AdminService from "../../services/admin.service";
import GoogleService from "../../services/google.service";
import ContentService from "../../services/content.service";
import ClientService from "../../services/client.service";
import CompanyMenu from "../../views/menu/CompanyMenu.vue";
import CompanyMixins from "../../mixins/CompanyMixins.vue";
import ContentMixins from "../../mixins/ContentMixins.vue";
import DashboardMixins from "../../mixins/DashboardMixins.vue";

import UserSettings from "../../components/UserSettings.vue";

export default {
  name: "DashboardLayout",
  mixins: [
    CompanyMixins, ContentMixins, DashboardMixins
  ],
  components: {
    UserSettings,
    CompanyMenu,
  },
  props: {},
  data() {
    return {
      title: "Dashboard Layout",
      dashboardCardTypeOptions: [],
      dashboardLayoutCards: [],
      enableSaveOptionsButton: false,
      pageNumber: 3,
      defaultGroup: { dashboardCardId: 0, id: 0, sequenceNumber: 100, dashboardCardTypeCode: "" },
      settings: [],
      tooltipConfigShow: ContentService.getWizardTooltip(),     
    };
  },
  methods: {
    loadData: function () {
      this.$root.processServerRequest("Retrieving dashboard options");
      DashboardService.getDashboardCardTypes(this.getDashboardCardTypesCallback, this);
      DashboardService.getDashboardCards(this.getDashboardCardsCallback, this);
    },
    getDashboardCardTypesCallback: function (response) {
      this.dashboardCardTypeOptions = response.data;
    },
    saveOptions: function () {
      let message = this.validateOptions();
      if (message == "") {
        this.$root.processServerRequest("Saving dashboard options");
        GoogleService.logClickEvent(ClientService.getClientName(), "Save Options", 0, this);
        DashboardService.saveDashboardCards(this.dashboardLayoutCards, this.getDashboardCardsCallback, this);
      } else {
        this.$notify(AdminService.displayErrorMessage({ text: message, duration: -1 }));
      }
    },
    validateOptions: function () {
      this.$notify({ group: "admin", clean: true });
      let errorMessage = "";
      let selectedCodes = this.dashboardLayoutCards.map((a) => a.dashboardCardTypeCode);
      let duplicatesExist = selectedCodes.some((element, index) => {
        if (element == ""){
          return false;
        }
        return selectedCodes.indexOf(element) !== index;
      });
      if (duplicatesExist) {
        errorMessage = "You can only include one dashboard card per position.";
      }
      return errorMessage;
    },
    getDashboardCardsCallback: function (response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.dashboardLayoutCards = response.data.data;
        let currentSequenceNumber = this.dashboardLayoutCards.length;
        while (this.dashboardLayoutCards.length < 6) {
          let cardToAdd = JSON.parse(JSON.stringify(this.defaultGroup));
          currentSequenceNumber += 1;
          cardToAdd.sequenceNumber = currentSequenceNumber;
          this.dashboardLayoutCards.push(cardToAdd);
        }
      } else {
        this.$notify(AdminService.displayErrorMessage({ text: response.data.message }));
      }
    },
  },
  created() {},
  mounted() {
    if (this.clientId != 0) {
      this.loadData();
    }
    this.$parent.displayShowMenuIcon = true;
  },
  computed: {
    clientId: function () {
      if (typeof this.$parent.clientId != "undefined") {
        return this.$parent.clientId;
      } else {
        return 0;
      }
    },
  },
  watch: {
    clientId: function () {
      this.loadData();
    },
  },
};
</script>
